import * as yup from 'yup';
import { ViewMode, FilterMode } from 'inside-fifa/api/generic-tables/dto';

export const UpdateConfigDialogSchema = yup.object({
    name: yup.string().required(),
    config: yup
        .object({
            columns: yup.array(yup.object()),
            filters: yup.object({
                isSearchBoxEnabled: yup.boolean(),
                customFilters: yup.array(),
            }),
            itemsPerPage: yup.number(),
            paginationType: yup.number(),
            defaultColumnOrder: yup.object(),

            // Special treatment fields
            columnTitle: yup.string().optional(),
            keyAttributeColumn: yup.string().optional(),
            keyAttributeColumnValues: yup
                .array()
                .of(
                    yup.object({
                        key: yup.string().required(),
                        color: yup.string().required(),
                        icon: yup.string().default(''),
                    }),
                )
                .optional()
                .default([]),

            viewMode: yup.number<ViewMode>().default(ViewMode.Table).required(),
            filterMode: yup.number<FilterMode>().default(FilterMode.Top).required(),
        })
        .required(),
    modifiedTimestamp: yup.string().required(),
});
